import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import clx from "classnames";
const styles = require("./styles.scss");
const GoToJob = () => {
    const [jobId, setJobId] = useState("");
    const history = useHistory();
    const handleKeyPress = (e) => {
        if (e.key === "Enter" || e.charCode === 0) {
            setJobId("");
            history.push(`/job/${jobId}`);
        }
    };
    return (React.createElement(Form.Control, { type: "text", name: "guid", placeholder: "Type job id and hit enter", onKeyPress: handleKeyPress, value: jobId, onChange: (e) => setJobId(e.target.value), className: clx(styles.goToJob) }));
};
export default GoToJob;
